export function StatusPill({
    label,
    value,
    tone = "neutral",
}) {

    const tones = {
        good:
            "border-emerald-500/30 bg-emerald-500/10 text-emerald-300",

        warn:
            "border-amber-500/30 bg-amber-500/10 text-amber-300",

        danger:
            "border-red-500/30 bg-red-500/10 text-red-300",

        neutral:
            "border-slate-700 bg-slate-800/60 text-slate-300",

        blue:
            "border-blue-500/30 bg-blue-500/10 text-blue-300",
    };


    return (
        <div
            className={
                `rounded-full border px-3 py-1 text-xs font-medium ${
                    tones[tone] ??
                    tones.neutral
                }`
            }
        >
            <span className="mr-1 text-slate-500">
                {label}
            </span>

            {value}
        </div>
    );
}